import { render } from "./QuestionsQuizSimuladoPratico.vue?vue&type=template&id=06af92f2&translate=no"
import script from "./QuestionsQuizSimuladoPratico.vue?vue&type=script&lang=js"
export * from "./QuestionsQuizSimuladoPratico.vue?vue&type=script&lang=js"

import "./QuestionsQuizSimuladoPratico.vue?vue&type=style&index=0&id=06af92f2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__